var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"tooltip-marker px-5",class:{
      'tooltip-marker-down': _vm.arrowDown,
      'tooltip-marker-right': _vm.arrowRight,
      'tooltip-marker-left': _vm.arrowLeft
    },attrs:{"id":"tooltip-marker"}},[_c('div',{staticClass:"font-weight-bold mr-2"},[_vm._v(" "+_vm._s(_vm.bodyText)+" ")]),_c('v-btn',{staticClass:"ss-btn-primary ss-btn-primary--md",attrs:{"depressed":""},on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }